<template>
  <p
    v-show="errorMgs"
    class="
      has-background-danger-light has-text-danger
      is-size-5
      has-text-centered has-text-weight-bold
      is-family-secondary
      p-2
      m-0
    "
  >
    Error! {{ errorMgs }}
  </p>
</template>

<script>
import errors from "../data/errors";
export default {
  name: "Error",
  data() {
    return {};
  },
  computed: {
    errorMgs: function () {
      const errorCode = this.$store.getters.error;
      if (!errorCode) return;
      return errors[errorCode];
    },
  },
  watch: {
    errorMgs: function (newValue) {
      if (newValue)
        setTimeout(() => {
          this.$store.commit("error");
        }, 3000);
    },
  },
};
</script>